// «صنّف لاحقاً» — المخرج من التوتر بين السرعة والدقة.
//
// سجّل المبلغ الآن عند الصندوق (نقرتان)، وصنّف على الأريكة مساءً (نقرة لكل حركة).
// الأنواع مرتّبة حسب ما اقترن سابقاً بهذه الوجهة، فمعظمها تأكيد بنقرة واحدة.

import { esc, dayLabel } from '../util.js';
import { updateEntry, destName, addType, stats } from '../store.js';
import { untypedEntries, likelyTypesFor } from '../model.js';
import { backBar, typeStrip, emptyState, amountBox, askName,
         loadingBlock, offlineBlock, errorBlock } from '../ui.js';

/**
 * range/label اختياريان: يأتيان من تنبيه التقرير فيقصران الكومة على تلك الفترة.
 * بدونهما الكومة هي كل الحركات بلا نوع — وهو السلوك حين يُفتح من الشاشة الرئيسية.
 */
export function freshDraft(opts = {}){
  return { skip: [], done: 0, range: opts.range || null, label: opts.label || '' };
}

// الكومة تُجلب وحدها (untyped=true) لا مع تاريخ المحفظة: الحركات بلا نوع
// قليلة بطبيعتها، فجلبها عبر كل التاريخ أرخص من تحميل التاريخ لشهر واحد.
const DAWN = new Date(2000, 0, 1).getTime();

export function rangeFor(app){
  const d = app.clsDraft;
  return { from: d.range ? d.range.f : DAWN,
           to:   d.range ? d.range.t : Date.now(),
           untyped: true };
}

export function render(app){
  const d = app.clsDraft;
  const scopeSub = d.label ? esc(d.label) : 'كل الحركات بلا نوع';
  if (app.loading)               return backBar('صنّف لاحقاً', scopeSub) + loadingBlock('الكومة');
  if (app.dataErr === 'offline') return backBar('صنّف لاحقاً', scopeSub)
    + offlineBlock('كومة التصنيف');
  if (app.dataErr)               return backBar('صنّف لاحقاً', scopeSub) + errorBlock(app.dataErr);

  const pile = untypedEntries(d.skip, d.range);
  const scope = d.label ? ` · ${esc(d.label)}` : '';

  if (!pile.length){
    // كومة الفترة فرغت، لكن قد تبقى حركات خارجها — نعرض المخرج بدل طريق مسدود
    // من العدّادات: النافذة المحمّلة مقصورة على الفترة فلا تعرف ما خارجها
    const rest = d.range ? Math.max(0, (stats().untypedCount || 0) - d.done) : 0;
    const body = d.done
      ? `صنّفتَ <b class="mono">${d.done}</b> حركة في هذه الجلسة.<br>` +
        (d.label ? `تقرير <b>${esc(d.label)}</b> حسب النوع صار مكتملاً.` : 'تقاريرك حسب النوع صارت مكتملة.')
      : 'كل حركات هذه الفترة مصنّفة.';
    return backBar('صنّف لاحقاً', d.label ? esc(d.label) : 'الكومة فارغة')
      + `<div class="scroll">${emptyState(
          d.range ? 'لا حركات بلا نوع في هذه الفترة' : 'لا توجد حركات بلا نوع', body)}
          ${rest ? `<div class="linkrow"><button type="button" data-act="all">
              تابع باقي الحركات (${rest})</button></div>` : ''}</div>`;
  }

  const e = pile[0];
  const order = likelyTypesFor(e.destId);
  const cap = `<span class="kd">${esc(destName(e.destId))}</span> · ${esc(dayLabel(new Date(e.occurredAt).getTime()))}`;

  return backBar('صنّف لاحقاً',
      `${pile.length} حركة بلا نوع${scope}${d.done ? ` · صنّفت ${d.done}` : ''}`)
    + amountBox(e.amount, e.currency, cap)
    + typeStrip(null, { order, wrap: true, addBtn: true,
        label: 'على ماذا كان هذا المبلغ؟', hint: 'الأرجح أولاً' })
    + '<div style="flex:1"></div>'
    + `<div class="linkrow">
        <button type="button" data-act="skip">تخطّي هذه</button>
        <button type="button" data-act="back">إنهاء</button>
      </div>`;
}

export function onClick(app, btn){
  const d = app.clsDraft;
  // بالنطاق نفسه الذي عُرض به — وإلا صنّفنا حركة غير التي أمام المستخدم
  const pile = untypedEntries(d.skip, d.range);

  if (btn.dataset.act === 'all'){
    d.range = null; d.label = '';
    app.render();
    return app.ensureData();      // النطاق اتّسع: نجلب بقية الكومة
  }

  if (btn.dataset.type){
    if (!pile.length) return;
    updateEntry(pile[0].id, { typeId: btn.dataset.type });
    d.done++;
    app.queueSync();
    return app.render();          // الكومة تتقلّص فينتقل تلقائياً للتالية
  }
  if (btn.dataset.add === 'type'){
    const name = askName('اسم النوع الجديد (على ماذا):');
    const created = name ? addType(name) : null;
    if (created && pile.length){
      updateEntry(pile[0].id, { typeId: created.id });
      d.done++;
      app.queueSync();
    }
    return app.render();
  }
  if (btn.dataset.act === 'skip'){
    if (pile.length) d.skip.push(pile[0].id);
    return app.render();
  }
  return false;
}
